module.exports = __webpack_public_path__ + "img/img-banner-custom-present.bcefea7a.png";